import { useEffect, useState } from 'react'
import { MessageCircle } from 'lucide-react'
import { onUnreadCountChange, show } from '@intercom/messenger-js-sdk'
import { ChatButtonClickedAnalytics } from '@/common/analytics/events/ChatButtonClickedAnalytics'
import { Button } from '@/common/ui/button'

const MAX_BADGE_COUNT = 99

export function MobileIntercomButton() {
    const [unreadCount, setUnreadCount] = useState(0)

    useEffect(() => {
        try {
            onUnreadCountChange((count: unknown) => {
                const safeCount =
                    typeof count === 'number' && Number.isFinite(count) ? Math.max(0, Math.floor(count)) : 0
                setUnreadCount(safeCount)
            })
        } catch {
            // ignore Intercom availability issues
        }
    }, [])

    const unreadBadgeValue = unreadCount > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : String(unreadCount)

    const handleOpenIntercom = () => {
        ChatButtonClickedAnalytics.track()

        try {
            show()
        } catch {
            // ignore if Intercom is unavailable
        }
    }

    return (
        <Button
            type="button"
            variant="ghost"
            size="icon"
            className="relative h-9 w-9 rounded-[96px] bg-white/70 p-2 shadow-[0px_4px_24px_0px_rgba(0,0,0,0.25)] backdrop-blur-[8px] md:hidden"
            aria-label={unreadCount > 0 ? 'Open messages' : 'Open support'}
            onClick={handleOpenIntercom}
        >
            <MessageCircle className="h-4 w-4 text-content-secondary" />
            {unreadCount > 0 && (
                <span
                    className="absolute -right-1 -top-1 min-w-4 rounded-full bg-destructive px-1 text-center text-[10px] font-semibold leading-4 text-white"
                    aria-label={`${unreadCount} unread messages`}
                >
                    {unreadBadgeValue}
                </span>
            )}
        </Button>
    )
}
